module.exports = __webpack_public_path__ + "static/img/The Tower.8f2f263.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/The Tower.jpg
// module id = 1323
// module chunks = 0